/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function ForeignCurrencyPaymentLedgerInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { 
    openingBalance = { debit: { foreign: 0, vnd: 0 }, credit: { foreign: 0, vnd: 0 } },
    details = [], 
    totalIncurred = { debit: { foreign: 0, vnd: 0 }, credit: { foreign: 0, vnd: 0 } },
    closingBalance = { debit: { foreign: 0, vnd: 0 }, credit: { foreign: 0, vnd: 0 } }
  } = values;

  const num = (v) => (v && v !== "" && !isNaN(v) ? parseFloat(v) : 0);
  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const addRow = () => {
    const newRow = {
      bookingDate: "",
      documentNumber: "",
      documentDate: "",
      description: "",
      correspondingAccount: "",
      exchangeRate: 0,
      debit: { foreign: 0, vnd: 0 },
      credit: { foreign: 0, vnd: 0 },
      balanceDebit: { foreign: 0, vnd: 0 },
      balanceCredit: { foreign: 0, vnd: 0 },
    };
    setFieldValue("details", [...details, newRow]);
  };

  const removeRow = (idx) => {
    setFieldValue("details", details.filter((_, i) => i !== idx));
  };

  // Auto Calculations & Running Balance
  useEffect(() => {
    // 1. Calculate VND for each row if foreign & exchangeRate are present
    const detailsWithVnd = details.map(d => {
        const rate = num(d.exchangeRate);
        return {
            ...d,
            debit: { ...d.debit, vnd: d.debit.foreign * rate },
            credit: { ...d.credit, vnd: d.credit.foreign * rate }
        };
    });

    // 2. Calculate Running Balance
    let totalD_F = 0, totalD_V = 0, totalC_F = 0, totalC_V = 0;
    
    // Starting net balance
    let currentNet_F = num(openingBalance.debit.foreign) - num(openingBalance.credit.foreign);
    let currentNet_V = num(openingBalance.debit.vnd) - num(openingBalance.credit.vnd);

    const newDetails = detailsWithVnd.map((d) => {
        const d_f = num(d.debit.foreign);
        const d_v = num(d.debit.vnd);
        const c_f = num(d.credit.foreign);
        const c_v = num(d.credit.vnd);

        totalD_F += d_f;
        totalD_V += d_v;
        totalC_F += c_f;
        totalC_V += c_v;

        currentNet_F = currentNet_F + d_f - c_f;
        currentNet_V = currentNet_V + d_v - c_v;

        // Determine balance side
        let bD = { foreign: 0, vnd: 0 };
        let bC = { foreign: 0, vnd: 0 };

        if (currentNet_F >= 0) bD.foreign = currentNet_F; else bC.foreign = Math.abs(currentNet_F);
        if (currentNet_V >= 0) bD.vnd = currentNet_V; else bC.vnd = Math.abs(currentNet_V);

        return { ...d, balanceDebit: bD, balanceCredit: bC };
    });

    const newTotalIncurred = {
      debit: { foreign: totalD_F, vnd: totalD_V },
      credit: { foreign: totalC_F, vnd: totalC_V },
    };

    // 3. Closing Balance (Final running balance state)
    let finalD = { foreign: 0, vnd: 0 };
    let finalC = { foreign: 0, vnd: 0 };
    if (currentNet_F >= 0) finalD.foreign = currentNet_F; else finalC.foreign = Math.abs(currentNet_F);
    if (currentNet_V >= 0) finalD.vnd = currentNet_V; else finalC.vnd = Math.abs(currentNet_V);

    const newClosing = { debit: finalD, credit: finalC };

    const hasChanged = 
      JSON.stringify(newDetails) !== JSON.stringify(details) ||
      JSON.stringify(newTotalIncurred) !== JSON.stringify(totalIncurred) ||
      JSON.stringify(newClosing) !== JSON.stringify(closingBalance);

    if (hasChanged) {
      setFieldValue("details", newDetails);
      setFieldValue("totalIncurred", newTotalIncurred);
      setFieldValue("closingBalance", newClosing);
    }
  }, [JSON.stringify(details.map(d => ({ fD: d.debit.foreign, fC: d.credit.foreign, r: d.exchangeRate }))), JSON.stringify(openingBalance)]);

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "12px", marginTop: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "60%" }}>
          <div>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.unit} onChange={(e) => setFieldValue("unit", e.target.value)} /></div>
          <div>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.address} onChange={(e) => setFieldValue("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "40%" }}>
          <div style={{ fontWeight: "bold" }}>Mẫu số S33-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase" }}>SỔ THEO DÕI THANH TOÁN BẰNG NGOẠI TỆ</h2>
        <div style={{ fontStyle: "italic", fontSize: "13px", marginTop: "5px" }}>(Dùng cho các TK 136, 138, 141, 244, 334, 336, 338, 344)</div>
        
        <div style={{ marginTop: 15 }}>Tài khoản: <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.accountNumber} onChange={(e) => setFieldValue("accountNumber", e.target.value)} /></div>
        <div style={{ marginTop: 5 }}>Đối tượng: <input disabled={containView} style={{ ...s.inputDotted, width: "300px", textAlign: "center" }} value={values.entityName} onChange={(e) => setFieldValue("entityName", e.target.value)} /></div>
        <div style={{ marginTop: 5 }}>Loại ngoại tệ: <input disabled={containView} style={{ ...s.inputDotted, width: "100px", textAlign: "center" }} value={values.currencyType} onChange={(e) => setFieldValue("currencyType", e.target.value)} /></div>
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "70px" }} rowSpan={3}>Ngày, tháng ghi sổ</th>
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={{ ...s.th, width: "150px" }} rowSpan={3}>Diễn giải</th>
              <th style={{ ...s.th, width: "60px" }} rowSpan={3}>TK đối ứng</th>
              <th style={{ ...s.th, width: "70px" }} rowSpan={3}>Tỷ giá hối đoái</th>
              <th style={s.th} colSpan={4}>Số phát sinh</th>
              <th style={s.th} colSpan={4}>Số dư</th>
              {!containView && <th style={{ ...s.th, width: "35px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "60px" }} rowSpan={2}>Số hiệu</th>
              <th style={{ ...s.th, width: "60px" }} rowSpan={2}>Ngày tháng</th>
              <th style={s.th} colSpan={2}>Nợ</th>
              <th style={s.th} colSpan={2}>Có</th>
              <th style={s.th} colSpan={2}>Nợ</th>
              <th style={s.th} colSpan={2}>Có</th>
            </tr>
            <tr>
               <th style={s.th}>Ngoại tệ</th>
               <th style={s.th}>Quy ra VND</th>
               <th style={s.th}>Ngoại tệ</th>
               <th style={s.th}>Quy ra VND</th>
               <th style={s.th}>Ngoại tệ</th>
               <th style={s.th}>Quy ra VND</th>
               <th style={s.th}>Ngoại tệ</th>
               <th style={s.th}>Quy ra VND</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>E</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>6</th>
              <th style={s.th}>7</th>
              <th style={s.th}>8</th>
              <th style={s.th}>9</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {/* OPENING BALANCE */}
            <tr style={{ fontWeight: "bold" }}>
              <td style={s.td} rowSpan={2}></td>
              <td style={s.td} rowSpan={2}></td>
              <td style={s.td} rowSpan={2}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>- Số dư đầu kỳ</td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td} colSpan={4}></td>
              <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={openingBalance.debit.foreign} onChange={(e) => setFieldValue("openingBalance.debit.foreign", e.target.value)} /></td>
              <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={openingBalance.debit.vnd} onChange={(e) => setFieldValue("openingBalance.debit.vnd", e.target.value)} /></td>
              <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={openingBalance.credit.foreign} onChange={(e) => setFieldValue("openingBalance.credit.foreign", e.target.value)} /></td>
              <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={openingBalance.credit.vnd} onChange={(e) => setFieldValue("openingBalance.credit.vnd", e.target.value)} /></td>
              {!containView && <td style={s.td} rowSpan={2}></td>}
            </tr>
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ ...s.td, padding: "0 8px" }}>- Số phát sinh</td>
              <td style={s.td}></td>
              <td style={s.td}></td>
              <td style={s.td} colSpan={8}></td>
            </tr>

            {/* DETAILS */}
            {(details || []).map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.bookingDate} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].bookingDate = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.documentNumber} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].documentNumber = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.documentDate} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].documentDate = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.description} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].description = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.correspondingAccount} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].correspondingAccount = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.exchangeRate} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].exchangeRate = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.debit.foreign} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].debit.foreign = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(item.debit.vnd)}</td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.credit.foreign} onChange={(e) => {
                  const newDetails = [...details];
                  newDetails[idx].credit.foreign = e.target.value;
                  setFieldValue("details", newDetails);
                }} /></td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(item.credit.vnd)}</td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(item.balanceDebit.foreign)}</td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(item.balanceDebit.vnd)}</td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(item.balanceCredit.foreign)}</td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(item.balanceCredit.vnd)}</td>
                {!containView && (
                  <td style={{ ...s.td, textAlign: "center" }}>
                    <button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button>
                  </td>
                )}
              </tr>
            ))}

            {/* TOTAL INCURRED */}
            <tr style={{ fontWeight: "bold" }}>
              <td style={s.td} rowSpan={2}></td>
              <td style={s.td} rowSpan={2}></td>
              <td style={s.td} rowSpan={2}></td>
              <td style={{ ...s.td, padding: "0 8px" }}>- Cộng số phát sinh</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(totalIncurred.debit.foreign)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(totalIncurred.debit.vnd)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(totalIncurred.credit.foreign)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px" }}>{fmt(totalIncurred.credit.vnd)}</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              {!containView && <td style={s.td} rowSpan={2}></td>}
            </tr>

            {/* CLOSING BALANCE */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={{ ...s.td, padding: "0 8px" }}>- Số dư cuối kỳ</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "center" }}>x</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px", color: "blue" }}>{fmt(closingBalance.debit.foreign)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px", color: "blue" }}>{fmt(closingBalance.debit.vnd)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px", color: "red" }}>{fmt(closingBalance.credit.foreign)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 4px", color: "red" }}>{fmt(closingBalance.credit.vnd)}</td>
            </tr>
          </tbody>
        </table>

        {!containView && (
          <SoftBox mt={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm dòng phát sinh</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER */}
      <div style={{ marginTop: "25px" }}>
        <div style={{ marginBottom: "5px" }}>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => setFieldValue("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.openingDate} onChange={(e) => setFieldValue("openingDate", e.target.value)} /></div>
      </div>

      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <b style={{ textTransform: "none" }}>Người ghi sổ</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => setFieldValue("ledgerClerk", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <b style={{ textTransform: "none" }}>Kế toán trưởng</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => setFieldValue("chiefAccountant", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "13px", marginBottom: "5px" }}>Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => setFieldValue("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => setFieldValue("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => setFieldValue("signingYear", e.target.value)} /></div>
          <b style={{ textTransform: "none" }}>Người đại diện theo pháp luật</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => setFieldValue("legalRepresentative", e.target.value)} /></SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
